<div class="lab-requeue">
    <div class="lab-requeue__container">
        <section class="lab-requeue__result">
            <ul class="lab-requeue__result__list">
                <li class="lab-requeue__result__item"
                *ngFor="let item of informationListToDisplay">
                    <span class="lab-requeue__result__name">
                        {{item.resourceName}}
                    </span>
                    <span class="lab-requeue__result__value">
                        {{item.resourceValue}}
                    </span>
                </li>
            </ul>
        </section>
        <section class="info-input-section" *ngIf="!errorMsg">
            <p class="form-help-text">Enter the <strong>requested pool yield</strong> below, and 
                we'll calculate the approximate result per library assuming each is equally 
                represented when the requeue is complete.<br/><br/></p>

            <div class="lab-requeue__requested_additional_yield">
                <label class="input-field__label" for="requestYieldInput">
                    Requested pool yield
                </label>
                <form 
                    name="formGroup"
                    [formGroup]="formGroup"
                    >
                    <lib-form-field #form
                        for="requestedYield"
                        [errorMessage]="getErrorMessage()"
                        [isValidateOnInputChange]="isValidateOnInputChange"
                    >    
                        <input
                            class="requestYieldInput"
                            id="requestYieldInput"
                            lib-input
                            type="number"
                            formControlName="requestedYield"
                            [value]="requestedAdditionalYield != null ? requestedAdditionalYield.toString(): null"
                            (input)="onYieldChange($event)"         
                        />
                    </lib-form-field>
                </form>
            </div> 
            <div class="lab-requeue__basePair_choices">
                <label class="input-field__label">
                    Unit of measurement
                </label>
                <div class="select">
                    <lib-select [formControl]="basePairUnitControl">
                        <lib-option
                            *ngFor="let option of basePairChoices"
                            [value]="option.abbreviation"
                            [label]="option.abbreviation">
                        </lib-option>
                    </lib-select>
                    <div *ngIf="isYieldExplanationVisible()" 
                        class="pull-left form-control inline form-help-text"> 
                        &asymp; {{ yieldPerLibrary || 0 | number: '0.0-0'  }} {{ selectedBasePairUnit.abbreviation }} per library
                    </div>  
                </div>
            </div>
        </section>
        <div>
            <lib-error-alert-message
                [alertMsg]="alertMsg"
                [errorMsg]="errorMsg">
            </lib-error-alert-message>
        </div>
    </div>
</div>
